// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"7d01225e","232":"2fe59409"}[chunkId] + ".chunk.css";
};